import { connect } from "react-redux";
import Listing from "./List";
import { bindActionCreators } from "redux";
import { userRequestList } from "../../../services/redux/userHelpdesk/action";

const mapStateToProps = (state) => ({
    requestList : state.UserHelpdesk.requestList,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators({
        userRequestList,
    }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Listing);